import { ASSETS, Chapter, Reveal } from "../presentation";

export default function S06Ultima88() {
  return (
    <section id="ultima-88" className="about-immersive theme-dark" data-testid="slide-ultima-88">
      <div className="about-immersive-media" data-testid="ultima88-media">
        <video src={ASSETS.ultima88Video} poster={ASSETS.ultima88Poster} autoPlay muted loop playsInline aria-label="Sunreef Ultima 88" />
      </div>
      <div className="about-immersive-scrim" />
      <div className="about-immersive-grain" />

      <div className="about-immersive-inner">
        <div className="sec-topbar" style={{ marginBottom: 0 }}>
          <Chapter ch="05" label="cannes premiere" testid="ultima88-chapter" />
          <span className="wordmark wordmark-sm">SUNREEF</span>
        </div>

        <div className="about-immersive-content">
          <Reveal><span className="eyebrow">.sunreef ultima 88</span></Reveal>
          <Reveal delay={1}>
            <img
              className="model-logo model-logo-88"
              src={ASSETS.u88Logo}
              alt="ULTIMA 88"
              data-testid="ultima88-logo"
            />
          </Reveal>

          <Reveal className="stat-row" delay={2} testid="ultima88-stats">
            <div className="stat">
              <span className="stat-num">Premiere</span>
              <span className="stat-label">.cannes yachting festival</span>
            </div>
            <div className="stat">
              <span className="stat-num">Design</span>
              <span className="stat-label">.performance & luxury</span>
            </div>
            <div className="stat">
              <span className="stat-num">UAE</span>
              <span className="stat-label">.made in the uae</span>
            </div>
          </Reveal>
        </div>

        <div className="about-immersive-foot">
          <span className="about-caption about-caption-corner" aria-hidden="true"></span>
        </div>
      </div>
    </section>
  );
}
